import { render, staticRenderFns } from "./GruposDeFeriados.vue?vue&type=template&id=6f9aca72"
import script from "./GruposDeFeriados.vue?vue&type=script&lang=js"
export * from "./GruposDeFeriados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports